module.exports = __webpack_public_path__ + "img/9788954430869.54aa9bb9.jpg";